import React, { Fragment } from 'react'
import styled from 'styled-components'
import Categories from './Categories'
import Holidays from '../Holidays'
import Video from '../Common/Video'
import Documents from '../Documents'
import LoadCalculator from '../../containers/LoadCalculator'
import { Content } from './Content'

export default ({ article, documents }) => {
  return (
    <Fragment>
      <Title>{article.name}</Title>
      <p>{article.title}</p>
      {article.holidays && <Holidays/>}
      <Content article={article}/>
      {
        article.video && (
          <VideoContainer><Video url={article.video}/></VideoContainer>
        )
      }
      {article.docs && <Documents documents={documents}/>}
      {article.calc && <LoadCalculator/>}
      {article.categories && <Categories categories={article.categories}/>}
    </Fragment>
  )
}

const Title = styled.h1`
  font-size: 2rem;
  
  @media all and (max-width: 400px) {
    font-size: 1.5rem;
  }
`

const VideoContainer = styled.div`
  div {
    @media all and (max-width: 990px) {
      width: 100% !important;
    }
  }
`
